import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import RealExamView from '../views/RealExamView.vue'
import TicketCategoryView from '../views/TicketCategoryView.vue'
import WrongQuestionsView from '../views/WrongQuestionsView.vue'
import MedicalInfoView from '../views/MedicalInfoView.vue'
import RoadSignsView from '../views/RoadSignsView.vue'
import FinesView from '../views/FinesView.vue'
import ResultView from '@/views/ResultView.vue'
import FinesPoints from '@/views/FinesPoints.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { public: true, title: 'Kirish' }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Bosh sahifa' }
  },
  {
    path: '/real-exam',
    name: 'realExam',
    component: RealExamView,
    meta: { title: 'Real imtihon' }
  },
  {
    path: '/tickets/:type/:ticketNumber?',
    name: 'ticketCategory',
    component: TicketCategoryView,
    meta: { title: 'Biletlar' }
  },
  {
    path: '/wrong-questions',
    name: 'wrongQuestions',
    component: WrongQuestionsView,
    meta: { title: 'Xato belgilagan savollarim' }
  },
  {
    path: '/medical-info',
    name: 'medicalInfo',
    component: MedicalInfoView,
    meta: { title: 'Tibbiyot ma’lumotlari' }
  },
  {
    path: '/road-signs',
    name: 'roadSigns',
    component: RoadSignsView,
    meta: { title: 'Yo‘l belgilari' }
  },
  {
    path: '/fines',
    name: 'fines',
    component: FinesView,
    meta: { title: 'Jarimalar' }
  },
  {
    path: '/fines-points',
    name: 'fines-points',
    component: FinesPoints,
    meta: { title: 'Jarima ballari' }
  },
  {
    path: '/result',
    name: 'result',
    component: ResultView,
    meta: { title: 'Natija' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('accessToken')
  const isPublicPage = to.meta.public === true

  if (!isPublicPage && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (isAuthenticated && isPublicPage) {
    const redirectPath = to.query.redirect || '/'
    next(redirectPath)
  } else {
    next()
  }
})

router.afterEach((to) => {
  document.title = to.meta?.title || 'Ilova'
})

export default router